import {
  FIND_SYNCHRO_HISTORY_REQUESTED,
  FIND_SYNCHRO_HISTORY_SUCCEEDED,
  FIND_SYNCHRO_HISTORY_FAILED,
  EXECUTE_SYNCHRO_REQUESTED,
  EXECUTE_SYNCHRO_SUCCEEDED,
  EXECUTE_SYNCHRO_FAILED,
  FIND_SYNCHRO_ONEDRIVE_REQUESTED,
  FindSynchroHistoryRequestedAction,
} from './types';
import { HttpRequestError } from '../../types';
import { SynchroFilterRequest } from '../../services/SynchroApi';

import { SynchroLogItem } from '../../components/SynchroDataGrid/handlerFactory';

export const findSynchroHistoryRequested = (
  payload: SynchroFilterRequest,
  sendToOndrive?: boolean
) => ({
  type: FIND_SYNCHRO_HISTORY_REQUESTED,
  payload,
  sendToOndrive: Boolean(sendToOndrive),
});

export const findSynchroHistorySucceeded = (payload: SynchroLogItem[]) => ({
  type: FIND_SYNCHRO_HISTORY_SUCCEEDED,
  payload,
});

export const findSynchroHistoryFailed = (error: HttpRequestError) => ({
  type: FIND_SYNCHRO_HISTORY_FAILED,
  payload: error,
});

export const executeSynchroRequested = (payload: SynchroFilterRequest) => ({
  type: EXECUTE_SYNCHRO_REQUESTED,
  payload,
});

export const executeSynchroSucceeded = () => ({
  type: EXECUTE_SYNCHRO_SUCCEEDED,
});

export const executeSynchroFailed = (error: HttpRequestError) => ({
  type: EXECUTE_SYNCHRO_FAILED,
  payload: error,
});
